import React, { useEffect, useState } from "react";
import becomAuthorImg from "images/become-radar.webp";
import { DEMO_POSTS, DEMO_BENEFICIOS } from "data/posts";
import HomeBanner from "components/banners/HomeBanner";
import BackgroundSection from "components/backgrounds/BackgroundSection";
import SectionSliderCategories from "components/categories/SectionSliderCategories";
import SectionPosts from "components/posts/SectionPosts";
import SectionStatistic from "components/about/SectionStatistic";
import SectionBecomeAnAuthor from "components/authors/SectionBecomeAnAuthor";
import { getInstitutional, InstitutionalResponse } from "services/PageService";
import { home } from "services/CategoryService";
import useAuth from "hooks/useAuth";

const PageHome: React.FC = () => {

  const urlBase = process.env.REACT_APP_BACKEND_API_URL + '/storage/images/institutional/banners/';
  const [institutional, setInstitutional] = useState<InstitutionalResponse | null>(null);
  const [categories, setCategories] = useState<any[] | null>(null);
  const MAGAZINE2_POSTS = DEMO_BENEFICIOS.filter((_, i) => i >= 0 && i < 7);

  const { token, user } = useAuth();

  const fetchData = async () => {
    try {
      const data = await getInstitutional(3);
      setInstitutional(data);
    } catch (error) {
      // Lidar com erros, se necessário
    }
  };

  const fetchCategories = async () => {
    try {
      const data = await home();
      setCategories(data);
    } catch (error) {
      // Lidar com erros, se necessário
    }
  };

  useEffect(() => {
    fetchData();
    fetchCategories();
  }, []);

  // Scroll automático para seção baseado no hash da URL
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const elementId = hash.substring(1); // Remove o #
      const element = document.getElementById(elementId);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100); // Pequeno delay para garantir que a página carregou
      }
    }
  }, []);

  useEffect(() => {

    if (!institutional) return;

    MAGAZINE2_POSTS[0].title = institutional?.texts?.find((e) => e.name == 'Cartão de contatos')?.text;
    // MAGAZINE2_POSTS[0].categories[0].name = institutional?.texts?.find((e) => e.name == 'Titulo do banner de categorias')?.text;
    MAGAZINE2_POSTS[0].featuredImage = urlBase + institutional?.banners?.find((e) => e.name == 'Cartão de contatos')?.banner_path;
    MAGAZINE2_POSTS[0].href = '/contatos';

    MAGAZINE2_POSTS[1].title = institutional?.texts?.find((e) => e.name == 'Cartão de parcerias')?.text;
    MAGAZINE2_POSTS[1].featuredImage = urlBase + institutional?.banners?.find((e) => e.name == 'Cartão de parcerias')?.banner_path;
    MAGAZINE2_POSTS[1].href = '/parceiros';

    MAGAZINE2_POSTS[2].title = institutional?.texts?.find((e) => e.name == 'Cartão de eventos')?.text;
    MAGAZINE2_POSTS[2].featuredImage = urlBase + institutional?.banners?.find((e) => e.name == 'Cartão de eventos')?.banner_path;
    MAGAZINE2_POSTS[2].href = '/eventos';
    
    MAGAZINE2_POSTS[3].title = institutional?.texts?.find((e) => e.name == 'Cartão de dicas')?.text;
    MAGAZINE2_POSTS[3].featuredImage = urlBase + institutional?.banners?.find((e) => e.name == 'Cartão de dicas')?.banner_path;
    MAGAZINE2_POSTS[3].href = '/dicas-geral';

    MAGAZINE2_POSTS[4].title = institutional?.texts?.find((e) => e.name == 'Cartão de classificados')?.text;
    MAGAZINE2_POSTS[4].featuredImage = urlBase + institutional?.banners?.find((e) => e.name == 'Cartão de classificados')?.banner_path;
    MAGAZINE2_POSTS[4].href = '/classificados';

    MAGAZINE2_POSTS[5].title = institutional?.texts?.find((e) => e.name == 'Cartão de radar social')?.text;
    MAGAZINE2_POSTS[5].featuredImage = urlBase + institutional?.banners?.find((e) => e.name == 'Cartão de radar social')?.banner_path;
    MAGAZINE2_POSTS[5].href = '/social';

  }, [institutional]);

  return (
    <div className="nc-PageHomeDemo4 relative" style={{overflow: 'hidden'}}>
      <div className="relative">

        <HomeBanner institutional={institutional} />
        
        <div className="relative overflow-hidden">
          <div className="container relative">
            
            {/* <SectionTrending
              heading=""
              className="py-16 lg:py-28"
              posts={DEMO_POSTS.filter((_, i) => i < 8)}
            /> */}

            {/* <div className="relative py-16">
              <BackgroundSection />
              <SectionSliderNewCategories
                heading="Subtopics of Travel"
                subHeading="Discover 286,833 beautiful places to go"
                categories={TRAVEL_SUBCATS}
              />
            </div> */}

            {/* <SectionMagazine6
              className="py-16 lg:py-28"
              heading="🧩 Editor Picks"
            /> */}

            <div className="mt-20" id="comunidades-radar">
              <div className="relative py-16 ">
                <BackgroundSection />
                <SectionSliderCategories
                  heading={institutional?.texts?.find((e) => e.name == 'Titulo do banner de categorias')?.text}
                  subHeading={institutional?.texts?.find((e) => e.name == 'Subtitulo do banner de categorias')?.text}
                  data={categories ?? []} 
                />
              </div>
            </div>

            {/* <SectionSubscribe2 className="py-16 lg:py-28" />

            <SectionAds />

            <SectionVideos className="py-16 lg:py-28" /> */}

            {/* <div className="relative py-16">
              <BackgroundSection />
              <SectionGridPosts
                headingIsCenter
                postCardName="card10V2"
                heading="Explore latest video articles"
                subHeading="Hover on the post card and preview video 🥡"
                posts={DEMO_POSTS_VIDEO.filter((_, i) => i > 5 && i < 12)}
                gridClass="sm:grid-cols-2 lg:grid-cols-3"
              />
            </div> */}

            <div id={'nosso_alcance'} className="relative py-16">
              <SectionStatistic institutional={institutional} />
            </div>
            <div id={'beneficios'}>
              <SectionPosts
                //className="py-16 lg:py-28"
                heading="Benefícios"
                posts={MAGAZINE2_POSTS}
              />
            </div><br /><br />

            {
              !token && (
                <div className="relative py-5 mb-20">
                  <BackgroundSection />
                  <SectionBecomeAnAuthor
                    className="py-16 lg:py-28"
                    rightImg={becomAuthorImg}
                  />
                </div>
              )
            }
          </div>

          {/* <div className="dark bg-neutral-800 dark:bg-black dark:bg-opacity-20 text-neutral-100">
            <div className="relative container">
              <SectionGridPosts
                className="py-16 lg:py-28"
                postCardName="card11"
                heading="Explore other latest articles"
                subHeading="Explore 1129 other articles"
                posts={DEMO_POSTS.filter((_, i) => i > 5 && i < 18)}
                gridClass="sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 lg:gap-8"
              />
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default PageHome;
